// openAuth 중앙 로그인(SSO) 연동 헬퍼.
//
// NEXT_PUBLIC_OPENAUTH_URL(예: https://auth.maus2020.com)이 설정돼 있으면 SSO 를
// 사용한다. 미설정이면 호출부가 기존 /login 페이지로 폴백한다(전환기 안전장치).

export const OPENAUTH_URL = process.env.NEXT_PUBLIC_OPENAUTH_URL || "";

/** SSO 가 켜져 있는지(중앙 로그인 URL 이 설정됐는지). */
export function ssoEnabled(): boolean {
  return OPENAUTH_URL.length > 0;
}

// logout() 이 user 를 null 로 바꾸면 (dashboard)/layout.tsx 의 인증 가드 effect 도
// 같은 렌더에서 "미인증 상태"를 감지해 즉시 ssoLoginRedirect 를 쏜다. 두 리다이렉트가
// 같은 tick 에 window.location.href 를 다투어 쓰면 나중 것이 이기는데, 그게 로그인
// 리다이렉트라서 openAuth 에 살아있는 SSO 세션으로 즉시 재로그인돼버려 "로그아웃이
// 안 되는" 것처럼 보인다. logout() 이 이 플래그를 먼저 세워 가드가 자기 리다이렉트를
// 양보하게 한다.
let loggingOut = false;

export function markLoggingOut(): void {
  loggingOut = true;
}

export function isLoggingOut(): boolean {
  return loggingOut;
}

/** 이 서비스가 openAuth 로부터 ticket 을 돌려받을 콜백 URL(고정, 쿼리 없음). */
export function callbackUri(): string {
  return `${window.location.origin}/auth/callback`;
}

/** 미인증 사용자를 openAuth 중앙 로그인으로 보낸다. 로그인 후 next 경로로 복귀. */
export function ssoLoginRedirect(next: string): void {
  try {
    sessionStorage.setItem("sso_next", next || "/home");
  } catch {
    /* sessionStorage 불가 환경 무시 */
  }
  const redirectUri = encodeURIComponent(callbackUri());
  window.location.href = `${OPENAUTH_URL}/sso/login?redirect_uri=${redirectUri}`;
}

/** 완전 로그아웃(single logout) — openAuth 세션까지 종료 후 다시 로그인 화면으로. */
export function ssoLogoutRedirect(): void {
  const back = encodeURIComponent(window.location.origin);
  window.location.href = `${OPENAUTH_URL}/sso/logout?redirect_uri=${back}`;
}

/** openAuth 프로필 수정 화면으로 이동(완료 후 원래 서비스로 복귀). */
export function ssoProfileRedirect(): void {
  const back = encodeURIComponent(window.location.origin + "/home");
  window.location.href = `${OPENAUTH_URL}/account/profile?redirect_uri=${back}`;
}

/** openAuth 사용자 관리 콘솔(/admin)을 새 탭에서 연다.
 *
 * id/name/email/division/team/level 은 openAuth 소유 필드라 logger 는 더 이상
 * 자체 편집 UI 를 두지 않는다(README §13-6) — 새 탭인 이유는 /admin 이 profile
 * 화면과 달리 redirect_uri 복귀를 지원하지 않아, 전체 리다이렉트로 열면 logger
 * 로 돌아올 방법이 없기 때문.
 */
export function openAdminConsole(): void {
  window.open(`${OPENAUTH_URL}/admin`, "_blank", "noopener,noreferrer");
}
